<template>
    <div class="custom-pagination">
        <div class="pagination-btn">
            <button
                class="pagination-text"
                @click="goToPage(currentPage - 1)"
                :disabled="currentPage === 1"
            >
                <img :src="getIcon + 'ChevronLeftOutline.png'" />
                Previous
            </button>
        </div>
        <div class="d-flex align-items-center">
            <div v-for="(page, index) in visiblePages" :key="index" class="paginations-number">
                <p @click="goToPage(page)" :class="{ active: currentPage === page }">
                    {{ page }}
                </p>
            </div>
        </div>
        <div class="pagination-btn">
            <button
                class="pagination-text"
                @click="goToPage(currentPage + 1)"
                :disabled="currentPage === totalPages"
            >
                Next
                <img :src="getIcon + 'ChevronRightOutline.png'" />
            </button>
        </div>
    </div>
</template>

<script>
    import checkScreen from '../../mixins/check-screen'

    export default {
        props: {
            currentPage: Number,
            totalPages: Number,
            visiblePagesCount: Number
        },
        mixins: [checkScreen],
        data: () => ({
            pagesCount: null
        }),
        computed: {
            visiblePages() {
                const halfRange = Math.floor(this.visiblePagesCount / 2)
                let startPage = Math.max(this.currentPage - halfRange, 1)
                let endPage = Math.min(startPage + this.visiblePagesCount - 1, this.totalPages)

                startPage = Math.max(endPage - this.visiblePagesCount + 1, 1)

                return Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i)
            },
            pageInfo() {
                return `${this.currentPage} of ${this.totalPages}`
            },
            getIcon() {
                return '/images/'
            }
        },
        methods: {
            goToPage(page) {
                if (page.toString().includes('of')) return
                this.$emit('page-change', page)
            }
        }
    }
</script>

<style lang="scss">
    @import '../../../sass/_variables.scss';
    .pagination-btn {
        display: flex;
        padding: 8px 24px 8px 20px;
        align-items: center;
        gap: 8px;
        cursor: pointer;
    }
    .pagination-text {
        display: flex;
        align-items: center;
        gap: 10px;
        color: #acacac;
        font-family: 'Instrument Sans';
        font-size: 16px;
        font-style: normal;
        font-weight: 550;
        width: 84px;
        line-height: 125%;
        margin: 0;
        background: transparent;
        border: none;
    }
    .custom-pagination {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 10px;
        width: 75%;
        margin-top: 70px;
    }
    .paginations-number p.active {
        border-radius: 8px;
        background: #cdeb09;
    }
    .paginations-number p {
        color: #8b8b8b;
        font-family: 'Instrument Sans';
        font-size: 16px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
        margin: 0;
        max-height: 36px;
        padding: 8px;
        cursor: pointer;
        text-wrap: nowrap;
    }
    @media (max-width: 600px) {
        .custom-pagination {
            width: 100%;
        }
        .pagination-btn {
            padding: 0;
        }
    }
</style>
